(() => {
  if (document.body.dataset.reviewReading !== 'complete') return;
  const root = document.querySelector('#reviews');
  if (!root) return;
  const threshold = 1000;
  function apply() {
    root.querySelectorAll('.mp-amazon-review, .spotlight-card').forEach(card => {
      if (card.dataset.readingReady) return;
      const quote = card.querySelector('blockquote');
      if (!quote) return;
      card.dataset.readingReady = 'true';
      const id = card.dataset.sourceReviewId || card.dataset.reviewId;
      const source = Array.from(root.querySelectorAll('.mp-amazon-review')).find(el => el.dataset.reviewId === id);
      // Featured winter cards preview long text; the original archive stays complete.
      const featuredWinter = document.body.dataset.product === 'winter' && card.classList.contains('spotlight-card');
      const showFull = !featuredWinter && (source || card).dataset.reviewDisplay === 'full';
      card.querySelectorAll('.spotlight-more, .mp-review-read-more').forEach(el => el.remove());
      quote.classList.remove('mp-review-text-collapsed');
      if (!showFull && quote.textContent.trim().length > threshold) {
        quote.classList.add('is-long');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'review-source-link';
        button.textContent = 'Read full review';
        button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', () => {
          const expanded = quote.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? 'Show less' : 'Read full review';
        });
        quote.after(button);
      }
    });
  }
  const observer = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('.spotlight-card,.mp-unified-spotlight') || node.querySelector('.spotlight-card'))))) apply();
  });
  observer.observe(root, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, {once: true});
  else apply();
})();
